export default "__VITE_ASSET__DACieEeU__"